import React from 'react';

export default function CalendarIcon() {
  return <svg className="calendar-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68">
    <title>Calendar</title>
    <g fillRule="evenodd">
      <path d="M17 14.57a4.852 4.852 0 0 0 4.857-4.856V4.857A4.852 4.852 0 0 0 17 0a4.852 4.852 0 0 0-4.857 4.857v4.857A4.852 4.852 0 0 0 17 14.57zm34 0a4.852 4.852 0 0 0 4.857-4.856V4.857A4.852 4.852 0 0 0 51 0a4.852 4.852 0 0 0-4.857 4.857v4.857A4.852 4.852 0 0 0 51 14.57"/>
      <path d="M7.286 60.714h53.428V21.857H7.286v38.857zm59.5-55.857h-8.5v6.178c0 3.415-3.522 5.965-7.165 5.965-3.64 0-7.406-2.55-7.406-5.965V4.857H24.286v6.178C24.286 14.45 20.643 17 17 17s-7.286-2.55-7.286-5.965V4.857h-8.5C.546 4.857 0 5.404 0 6.07v60.716C0 67.454.546 68 1.214 68h65.572c.667 0 1.214-.546 1.214-1.214V6.07c0-.667-.547-1.214-1.214-1.214z"/>
    </g>
  </svg>;
}



// WEBPACK FOOTER //
// ./modules/Common/components/svg/CalendarIcon.js